import React from "react";
import { mapContextToDataTable as mapData } from "./Helper";
import ReusableDataTable from "src/components/table/ReusableDataTable";
import GetContextColumns from "./ColumnDefinition/ContextColumn/GetContextColumns";

const ContextTable = ({ data, handleOpenPopup, handleDelete, status }) => {
  const columns = GetContextColumns({
    handleOpenPopup,
    handleDelete,
    status,
  });

  return (
    <ReusableDataTable columns={columns} data={mapData(data)} maxHeight={500} />
  );
};

export default ContextTable;
